module.exports = __webpack_public_path__ + "media/categories/2039-6ba2664f.svg";